var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"img-container w-64 mx-auto flex items-center justify-center"},[_c('img',{staticClass:"pr-5",attrs:{"src":require("@/assets/images/logo/koblatil.png"),"alt":"Kobla"}})])
}]

export { render, staticRenderFns }